module.exports = __webpack_public_path__ + "static/media/teacher11.f0351672.png";